import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, SpinButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";
import DatePickerPL from "../../Components/DatePickerPL";

function EditFinalization(props) {
    const [user] = useContext(AuthContext);
    const [transferDate, setTransferDate] = useState('');
    const [finalizationDate, setFinalizationDate] = useState('');
    const [finalizationNumber, setFinalizationNumber] = useState('')
    const [finalDivider, setFinalDivider] = useState('')
    const [shares, setShares] = useState('')
    const [locationNumber, setLocationNumber] = useState('')
    const [whole, setWhole] = useState('')

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            transfer_date: dbDate(transferDate),
            finalization_date: dbDate(finalizationDate),
            finalization_number: finalizationNumber,
            final_divider: finalDivider,
            shares: shares,
            whole: whole,
            location_number: locationNumber
        };

        fetch(`/api/finalization/${props.edit.transaction_id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err)
            })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditFinalization'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    useEffect(() => {
        setTransferDate(props.edit.transfer_date !== null ? new Date(props.edit.transfer_date) : null);
        setFinalizationDate(props.edit.finalization_date !== null ? new Date(props.edit.finalization_date) : null);
        setShares(props.edit.shares !== null ? props.edit.shares : null);
        setFinalDivider(props.edit.final_divider !== null ? props.edit.final_divider : null)
        setWhole(props.edit.whole !== null ? props.edit.whole : null)
        setLocationNumber(props.edit.location_number !== null ? props.edit.location_number : null)
    }, [props.edit])

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Dane Odbioru"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditFinalization'>
                <TextField
                    label={"Numer aktu przeniesienia własności"}
                    onChange={(e) => setFinalizationNumber(e.target.value || '')}
                    value={finalizationNumber}
                />
                <TextField
                    label={"Udział w nieruchomości wspólnej"}
                    onChange={(e) => setShares(e.target.value || '')}
                    value={shares}
                />
                <TextField
                    label={"Numer działki"}
                    onChange={(e) => setLocationNumber(e.target.value || '')}
                    value={locationNumber}
                />

                <SpinButton
                    label={'Powierzchnia powykonawcza:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={finalDivider}
                    onChange={(e) => setFinalDivider(e.target.value || '')}
                />
                <SpinButton
                    label={'Rozmiar działki:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={whole}
                    onChange={(e) => setWhole(e.target.value || '')}
                    />


                <DatePickerPL
                    label="Data Przekazania"
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={transferDate}
                    onSelectDate={(e) => setTransferDate(e || '')}
                />
                <DatePickerPL
                    label="Data Finalizacji Umowy"
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={finalizationDate}
                    onSelectDate={(e) => setFinalizationDate(e || '')}
                />
            </form>
        </Panel>
    )
}

export default EditFinalization;